import { z } from 'zod';

export const contactSchema = z.object({
  companyName: z.string().min(2, '회사명을 입력해주세요'),
  contactPerson: z.string().min(2, '담당자명을 입력해주세요'),
  email: z.string().email('올바른 이메일 형식이 아닙니다'),
  phone: z.string().regex(/^01[0-9]-?[0-9]{4}-?[0-9]{4}$/, '올바른 전화번호 형식이 아닙니다'),
  projectType: z.enum(['web', 'mobile', 'both', 'solution'], {
    errorMap: () => ({ message: '프로젝트 유형을 선택해주세요' })
  }),
  budget: z.string().transform((val) => {
    const num = parseInt(val, 10);
    return isNaN(num) ? 0 : num;
  }).refine((val) => val !== 0, {
    message: '예산을 입력해주세요'
  }),
  timeline: z.string().min(1, '프로젝트 일정을 입력해주세요'),
  description: z.string().min(10, '프로젝트 설명을 10자 이상 입력해주세요'),
});

export const PROJECT_TYPES = {
  web: '웹 개발',
  mobile: '모바일 앱',
  both: '웹 + 모바일',
  solution: '솔루션 개발'
};

